export const STOCKISTS = [
  {
    state: "VIC",
    stores: [
      {
        name: "Tiles Mate",
        suburb: "Unit 7/150 Palmers Rd, Truganina VIC 3029",
        phone: "1300 680 580",
        coords: "-37.8420122,144.7471689",
        mapsUrl: "https://maps.app.goo.gl/DfAv9NSBGHDP4bH26",
      },
    ],
  },
  { state: "NSW", stores: [] },
  { state: "QLD", stores: [] },
  { state: "WA", stores: [] },
  { state: "SA", stores: [] },
];
